import { List } from 'immutable';
/**
 * ImageGallery state
 *
 * @export
 * @class ImageGalleryState
 */
var ImageGalleryState = /** @class */ (function () {
    function ImageGalleryState() {
        /**
         * Image gallery is open {true} or not {false}
         *
         * @type {Boolean}
         * @memberof ImageGalleryState
         */
        this.status = false;
        /**
         * The list of image
         */
        this.images = List();
        /**
         * Selected image name
         */
        this.selectImage = '';
        /**
         * Selected image address
         */
        this.selectURL = '';
        /**
         * If image gallery is loaded {true} or not false
         */
        this.loaded = false;
        /**
         * Images address list
         */
        this.imageURLList = {};
        /**
         * Store image requested
         */
        this.imageRequests = {};
    }
    return ImageGalleryState;
}());
export { ImageGalleryState };



//////////////////
// WEBPACK FOOTER
// ./src/store/reducers/imageGallery/ImageGalleryState.ts
// module id = 564
// module chunks = 50